import { Folder } from '@mui/icons-material'
import React from 'react'

export default function HeaderGroup({ group }) {
  return (
    <div>
         <div className="bg-gradient-to-r from-[#0b3a5c] to-[#135e96] rounded-lg px-6 py-3 shadow-md">
                                      <div className="flex items-center gap-3">
                                        <Folder className="w-5 h-5 text-white" />
                                        <h3 className="text-lg font-bold text-white">
                                          {group?.groupName}
                                        </h3>
                                        <span className="text-blue-100 text-sm">
                                          ({group?.questions.length} {group?.questions.length === 1 ? "Question" : "Questions"})
                                        </span>
                                      </div>
                                    </div>
    </div>
  )
}
